import axios from 'axios';

export const apiConfig = axios.create({
  baseURL: process.env.VUE_APP_LOCAL_API,
});

export const apiSendEmailConfig = axios.create({
  baseURL: process.env.VUE_APP_COMMUNICATOR_API,
});

export const apiGix = axios.create({
  baseURL: process.env.VUE_APP_GIX,
});

export const apiLoginAuth = axios.create({
  baseURL: `${process.env.VUE_APP_GLOBALACCOUNT_API}/login/auth`,
});
export const terrabusiness = axios.create({
  baseURL: `${process.env.VUE_APP_TERRABUSINESS}`,
});
export const apiLoginGA = axios.create({
  baseURL: `${process.env.VUE_APP_GLOBALACCOUNT_API}`,
});

export const apiCar = axios.create({
  baseURL: `${process.env.VUE_APP_CAR_API}`,
});
export const apiTerraWise = axios.create({
  baseURL: `${process.env.VUE_APP_TERRAWISE_API}`,
});

export const apiTmx = axios.create({
  baseURL: `${process.env.VUE_APP_TMX_API}`,
});

export const apiUpdateContact = axios.create({
  baseURL: `${process.env.VUE_APP_BLIPCHAT_COMMANDS_API}`,
});

export async function refreshTmxToken() {
  // eslint-disable-next-line consistent-return
  return new Promise((resolve, reject) => {
    try {
      apiTmx({
        method: 'post',
        url: `${process.env.VUE_APP_TMX_API}/oauth/token`,
        data: encodeURI(`grant_type=password&username=${process.env.VUE_APP_USER_TMX}&password=${process.env.VUE_APP_PSW_TMX}&client_id=ngAuthApp&productId=1&language=pt-BR&dns=${process.env.VUE_APP_DNS}`),
      })
        .then(async (response) => {
          sessionStorage.setItem('chave', (`Bearer ${response.data.access_token}`));
          return resolve(response);
        })
        .catch((err) => reject(err));
    } catch (err) {
      return reject(err);
    }
  });
}

function unauthorizedIntersecptor(apiClient) {
  return async (error) => {
    if ([401].includes(error.response.status)) {
      await refreshTmxToken();
      const tmxToken = sessionStorage.getItem('chave');
      const params = error.config;
      params.headers.Authorization = tmxToken;
      return new Promise((resolve) => {
        apiClient(params).then((response) => {
          resolve(response);
        });
      });
    }
    return Promise.reject(error);
  };
}

terrabusiness.interceptors.response.use((response) => response, unauthorizedIntersecptor(terrabusiness));
apiConfig.interceptors.response.use((response) => response, unauthorizedIntersecptor(apiConfig));
apiTmx.interceptors.response.use((response) => response, unauthorizedIntersecptor(apiTmx));

apiConfig.interceptors.request.use(
  async (config) => {
    const tmxToken = sessionStorage.getItem('chave');
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: tmxToken,
      },
    };
  },
  (error) => Promise.reject(error),
);
